var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Ordercontent" },
    [
      _c(
        "van-tabs",
        {
          on: { click: _vm.changeTab },
          model: {
            value: _vm.active,
            callback: function($$v) {
              _vm.active = $$v
            },
            expression: "active"
          }
        },
        [
          _c(
            "van-tab",
            { attrs: { title: "全部" } },
            [
              _vm._l(_vm.OrderList, function(item, i) {
                return _vm.OrderList
                  ? _c(
                      "van-swipe-cell",
                      {
                        key: i,
                        attrs: {
                          "right-width": 80,
                          "left-width": 0,
                          disabled: item.status != 0,
                          "on-close": _vm.onClose
                        }
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "billBar",
                            attrs: { href: "javascript:;" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.gotoOrderPay(item)
                              }
                            }
                          },
                          [
                            _c(
                              "van-row",
                              [
                                _c(
                                  "van-col",
                                  {
                                    staticClass: "title",
                                    attrs: { span: "24" }
                                  },
                                  [
                                    _c("i", { staticClass: "icon" }),
                                    _vm._v(_vm._s(item.create_time))
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "van-col",
                                  {
                                    staticClass: "cont",
                                    attrs: { span: "24" }
                                  },
                                  [
                                    _c(
                                      "van-col",
                                      {
                                        staticClass: "address",
                                        attrs: { span: "24" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            item.city + item.area + item.address
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    item.status == 0
                                      ? _c(
                                          "van-col",
                                          {
                                            staticClass: "money",
                                            attrs: { span: "18" }
                                          },
                                          [
                                            _vm._v("待缴金额："),
                                            _c(
                                              "span",
                                              { staticClass: "orange" },
                                              [
                                                _vm._v(
                                                  "¥ " + _vm._s(item.money)
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.status == 1
                                      ? _c(
                                          "van-col",
                                          {
                                            staticClass: "money",
                                            attrs: { span: "18" }
                                          },
                                          [
                                            _vm._v(
                                              "本季已缴热费：¥ " +
                                                _vm._s(item.money)
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "van-col",
                                      {
                                        staticClass: "payBtn",
                                        attrs: { span: "6" }
                                      },
                                      [
                                        item.status == 0
                                          ? _c(
                                              "van-button",
                                              {
                                                staticClass: "solidBtn",
                                                attrs: {
                                                  round: "",
                                                  type: "danger"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.goPayment(
                                                      item.roomId
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("去缴费")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.status != 0
                                          ? _c(
                                              "van-button",
                                              {
                                                staticClass: "hollowBtn",
                                                attrs: {
                                                  round: "",
                                                  type: "danger"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.gotoPath(
                                                      "/reportrepair",
                                                      item
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("去报修")]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("van-button", {
                          attrs: {
                            slot: "right",
                            square: "",
                            type: "danger",
                            text: "删除"
                          },
                          slot: "right"
                        })
                      ],
                      1
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm.OrderList.length == 0
                ? _c(
                    "van-row",
                    { staticClass: "noPayBar" },
                    [
                      _c("van-col", {
                        staticClass: "noPayPC",
                        attrs: { span: "24" }
                      }),
                      _vm._v(" "),
                      _c(
                        "van-col",
                        { staticClass: "text1 orange", attrs: { span: "24" } },
                        [_vm._v("没有找到该用户！")]
                      ),
                      _vm._v(" "),
                      _c(
                        "van-col",
                        { staticClass: "text2", attrs: { span: "24" } },
                        [_vm._v("去试试【自主信息填写缴费】吧！")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "van-tab",
            { attrs: { title: "未缴费" } },
            [
              _vm._l(_vm.OrderList, function(item, i) {
                return _vm.OrderList
                  ? _c(
                      "van-swipe-cell",
                      {
                        key: i,
                        attrs: {
                          "right-width": 80,
                          "left-width": 0,
                          disabled: item.status != 0,
                          "on-close": _vm.onClose
                        }
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "billBar",
                            attrs: { href: "javascript:;" },
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.gotoOrderPay(item)
                              }
                            }
                          },
                          [
                            _c(
                              "van-row",
                              [
                                _c(
                                  "van-col",
                                  {
                                    staticClass: "title",
                                    attrs: { span: "24" }
                                  },
                                  [
                                    _c("i", { staticClass: "icon" }),
                                    _vm._v(_vm._s(item.create_time))
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "van-col",
                                  {
                                    staticClass: "cont",
                                    attrs: { span: "24" }
                                  },
                                  [
                                    _c(
                                      "van-col",
                                      {
                                        staticClass: "address",
                                        attrs: { span: "24" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            item.city + item.area + item.address
                                          )
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    item.status == 0
                                      ? _c(
                                          "van-col",
                                          {
                                            staticClass: "money",
                                            attrs: { span: "18" }
                                          },
                                          [
                                            _vm._v("待缴金额："),
                                            _c(
                                              "span",
                                              { staticClass: "orange" },
                                              [
                                                _vm._v(
                                                  "¥ " + _vm._s(item.money)
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    item.status == 1
                                      ? _c(
                                          "van-col",
                                          {
                                            staticClass: "money",
                                            attrs: { span: "18" }
                                          },
                                          [
                                            _vm._v(
                                              "本季已缴热费：¥ " +
                                                _vm._s(item.money)
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "van-col",
                                      {
                                        staticClass: "payBtn",
                                        attrs: { span: "6" }
                                      },
                                      [
                                        item.status == 0
                                          ? _c(
                                              "van-button",
                                              {
                                                staticClass: "solidBtn",
                                                attrs: {
                                                  round: "",
                                                  type: "danger"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.goPayment(
                                                      item.roomId
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("去缴费")]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("van-button", {
                          attrs: {
                            slot: "right",
                            square: "",
                            type: "danger",
                            text: "删除"
                          },
                          slot: "right"
                        })
                      ],
                      1
                    )
                  : _vm._e()
              }),
              _vm._v(" "),
              _vm.OrderList.length == 0
                ? _c(
                    "van-row",
                    { staticClass: "noPayBar" },
                    [
                      _c("van-col", {
                        staticClass: "noPayPC",
                        attrs: { span: "24" }
                      }),
                      _vm._v(" "),
                      _c(
                        "van-col",
                        { staticClass: "text1 orange", attrs: { span: "24" } },
                        [_vm._v("没有找到该用户！")]
                      ),
                      _vm._v(" "),
                      _c(
                        "van-col",
                        { staticClass: "text2", attrs: { span: "24" } },
                        [_vm._v("去试试【自主信息填写缴费】吧！")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "van-tab",
            { attrs: { title: "已缴费" } },
            [
              _vm._l(_vm.OrderList, function(item, i) {
                return _c(
                  "a",
                  {
                    key: i,
                    staticClass: "billBar",
                    attrs: { href: "javascript:;" },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.gotoOrderPay(item)
                      }
                    }
                  },
                  [
                    _c(
                      "van-row",
                      [
                        _c(
                          "van-col",
                          { staticClass: "title", attrs: { span: "24" } },
                          [
                            _c("i", { staticClass: "icon" }),
                            _vm._v(_vm._s(item.create_time)),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: item.status == "5",
                                    expression: "item.status=='5'"
                                  }
                                ],
                                staticStyle: {
                                  "margin-left": "10px",
                                  padding: "2px 5px",
                                  "background-color": "#ff0000",
                                  color: "#fff"
                                }
                              },
                              [_vm._v("异常")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "van-col",
                          { staticClass: "cont", attrs: { span: "24" } },
                          [
                            _c(
                              "van-col",
                              { staticClass: "address", attrs: { span: "24" } },
                              [
                                _vm._v(
                                  _vm._s(item.city + item.area + item.address)
                                )
                              ]
                            ),
                            _vm._v(" "),
                            item.status == 0
                              ? _c(
                                  "van-col",
                                  {
                                    staticClass: "money",
                                    attrs: { span: "18" }
                                  },
                                  [
                                    _vm._v("待缴金额："),
                                    _c("span", { staticClass: "orange" }, [
                                      _vm._v("¥ " + _vm._s(item.curMoney))
                                    ])
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            item.status == 1
                              ? _c(
                                  "van-col",
                                  {
                                    staticClass: "money",
                                    attrs: { span: "18" }
                                  },
                                  [
                                    _vm._v(
                                      "本季已缴热费：¥ " + _vm._s(item.curMoney)
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "van-col",
                              { staticClass: "payBtn", attrs: { span: "6" } },
                              [
                                item.status == 0
                                  ? _c(
                                      "van-button",
                                      {
                                        staticClass: "solidBtn",
                                        attrs: { round: "", type: "danger" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.goPayment(item.roomId)
                                          }
                                        }
                                      },
                                      [_vm._v("去缴费")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.status != 0
                                  ? _c(
                                      "van-button",
                                      {
                                        staticClass: "hollowBtn",
                                        attrs: { round: "", type: "danger" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.gotoPath(
                                              "/reportrepair",
                                              item
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v("去报修")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                item.status != 0 &&
                                item.invoice_apply_status == 0 &&
                                item.issueCount == 0 &&
                                _vm.isShowApply
                                  ? _c(
                                      "van-button",
                                      {
                                        staticClass: "hollowBtn",
                                        staticStyle: { "margin-top": "10px" },
                                        attrs: { round: "", type: "danger" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.gotoInvoicing(item)
                                          }
                                        }
                                      },
                                      [_vm._v("申请开票")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _vm.OrderList.length == 0
                ? _c(
                    "van-row",
                    { staticClass: "noPayBar" },
                    [
                      _c("van-col", {
                        staticClass: "noPayPC",
                        attrs: { span: "24" }
                      }),
                      _vm._v(" "),
                      _c(
                        "van-col",
                        { staticClass: "text1 orange", attrs: { span: "24" } },
                        [_vm._v("没有找到该用户！")]
                      ),
                      _vm._v(" "),
                      _c(
                        "van-col",
                        { staticClass: "text2", attrs: { span: "24" } },
                        [_vm._v("去试试【自主信息填写缴费】吧！")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d486588e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d486588e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Order/Order.vue
// module id = null
// module chunks = 